module.exports = __webpack_public_path__ + "img/BE0404476835.158cd826.png";